import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IApproveClusterNodeParams {
    clusterId: string;
    nodeId: string;
}

export interface IApproveClusterNodeResult extends IResult {
  success?: {
    nodeId: string;
    nodeName: string;
    nodeIp: string;

};
  error?: BaasEdgePoolError;
}

export class ApproveClusterNodeRequest extends Request<IApproveClusterNodeParams, IApproveClusterNodeResult> {
  constructor(params: IApproveClusterNodeParams) {
    super('approveClusterNode', params);
  }
}
